import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ClientAuthContext = createContext(null);

export function ClientAuthProvider({ children }) {
  const [client, setClient] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    api.get("/client-auth/me")
      .then(({ data }) => setClient(data))
      .catch(() => setClient(false))
      .finally(() => setReady(true));
  }, []);

  const login = async (login_id, password) => {
    const { data } = await api.post("/client-auth/login", { login_id, password });
    setClient(data);
    return data;
  };

  const logout = async () => {
    await api.post("/client-auth/logout");
    setClient(false);
  };

  return <ClientAuthContext.Provider value={{ client, ready, login, logout }}>{children}</ClientAuthContext.Provider>;
}

export function useClientAuth() {
  return useContext(ClientAuthContext);
}
